import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaChevronDown } from 'react-icons/fa';
import { useMobile } from '../hooks/useMobile';
import AccessAppsModal from '../modals/AccessAppsModal';

const CareersHeader: React.FC = () => {
  const { isMobile } = useMobile();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [accessAppsModalOpen, setAccessAppsModalOpen] = useState(false);

  const isJobSearch = location.pathname === '/careers';
  const isSavedJobs = location.pathname === '/saved-jobs';

  const handleLoginToHRMSClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setAccessAppsModalOpen(true);
    setMobileMenuOpen(false);
  };

  return (
    <header className="bg-white fixed top-0 left-0 right-0 z-50 shadow-sm">
      <div className="w-full">
        {/* Title */}
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 ${isMobile ? 'text-center' : ''}`}>
          <h1 className={`text-2xl font-bold text-blue-600`}>Club Corners</h1>
        </div>
        {/* Navigation Bar - Fixed */}
        <nav className="text-white w-full">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 bg-blue-600">
            {isMobile ? (
              <div className="flex items-center justify-between py-2 w-full">
                <span className="font-semibold">Careers</span>
                <button
                  onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                  className="p-2 text-white hover:opacity-80 transition-opacity flex items-center"
                  aria-label="Toggle menu"
                >
                  <FaChevronDown className={`w-5 h-5 transition-transform duration-200 ${mobileMenuOpen ? 'rotate-180' : ''}`} />
                </button>
              </div>
            ) : (
              <div className="flex items-center justify-between py-2">
                <span className="font-semibold">Careers</span>
                <div className="flex items-center space-x-6">
                  <Link 
                    to="/careers" 
                    className={`text-sm ${isJobSearch ? 'underline' : 'hover:underline'}`}
                  >
                    Job Search
                  </Link>
                  <Link 
                    to="/saved-jobs" 
                    className={`text-sm ${isSavedJobs ? 'underline' : 'hover:underline'}`}
                  >
                    Saved Jobs
                  </Link>
                  <button 
                    onClick={handleLoginToHRMSClick}
                    className="hover:underline text-sm text-left"
                  >
                    Login to HRMS
                  </button>
                </div>
              </div>
            )}
          </div>
          {/* Mobile Dropdown Menu */}
          {isMobile && mobileMenuOpen && (
            <div className="border-t border-blue-500">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <Link
                  to="/careers"
                  className="block py-3 text-sm text-black"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Job Search
                </Link>
                <div className="border-t border-blue-500"></div>
                <Link
                  to="/saved-jobs"
                  className="block py-3 text-sm text-black"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Saved Jobs
                </Link>
                <div className="border-t border-blue-500"></div>
                <button
                  onClick={handleLoginToHRMSClick}
                  className="block w-full text-left py-3 text-sm text-black"
                >
                  Login to HRMS
                </button>
              </div>
            </div>
          )}
        </nav>
      </div>
      <AccessAppsModal 
        open={accessAppsModalOpen} 
        onClose={() => setAccessAppsModalOpen(false)} 
      />
    </header>
  );
};

export default CareersHeader;

